export default __webpack_public_path__ + "static/lets_dicuss_ae-c8ecb3c99b1620059f801a3d3089245d.webp";